export default __webpack_public_path__ + "static/media/volleyball-25765_640.20505270.png";